var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Missing component "),_c('strong',[_vm._v(_vm._s(_vm.item.component))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm._f("pretty")(_vm.item)))])])}
var staticRenderFns = []

export { render, staticRenderFns }